import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Typography,
  useTheme,
} from "@mui/material";

/**
 * Generic reusable select form for levels (Impact, Likelihood, etc.)
 * @param {Object} props
 * @param {string} props.label - The label for the select field
 * @param {Array} props.options - Array of { value, label, description }
 * @param {any} props.value - Current selected value
 * @param {function} props.onChange - Callback with (value)
 * @param {boolean} [props.disabled] - Whether the select is disabled
 */
export function LevelSelectForm({
  label,
  options,
  value,
  onChange,
  disabled = false,
}) {
  const theme = useTheme();
  return (
    <FormControl fullWidth size="small" disabled={disabled}>
      <InputLabel>{label}</InputLabel>
      <Select
        value={value ?? ""}
        label={label}
        onChange={(e) => onChange(e.target.value)}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            <Box>
              <Typography variant="body2">{option.label}</Typography>
              {option.description && (
                <Typography
                  variant="caption"
                  style={{ color: theme.customColors.text.secondary }}
                >
                  {option.description}
                </Typography>
              )}
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
